var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',[_vm._v("Users")]),_vm._l((_vm.users),function(user){return _c('div',{key:user.id},[_c('p',[_vm._v(_vm._s(user.email)),_c('span',[_vm._v(_vm._s(user.admin ? ' (Admin)' : ''))])])])})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }